'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _TabBar = require('./TabBar');

var _TabBar2 = _interopRequireDefault(_TabBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    // add isControlled logic here
    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.onTabClick = function (e, v) {
      _this.setState({
        currentValue: v
      });
      _this.props.onChange && _this.props.onChange(e, v);
    };

    _this.onKeyDown = function (e, v) {
      if (e.keyCode === _keyCode2.default.ENTER) _this.onTabClick(e, v);
    };

    _this.renderHeader = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          renderTabBar = _this$props.renderTabBar,
          _this$props$centered = _this$props.centered,
          centered = _this$props$centered === undefined ? false : _this$props$centered,
          size = _this$props.size,
          tabBarClass = _this$props.tabBarClass,
          _this$props$secondary = _this$props.secondary,
          secondary = _this$props$secondary === undefined ? false : _this$props$secondary;

      var header = _react2.default.cloneElement(_react2.default.createElement(_TabBar2.default, { key: 'tabbar' }), {
        onTabClick: _this.onTabClick,
        onKeyDown: _this.onKeyDown,
        value: _this.state.currentValue,
        centered: centered,
        size: size,
        tabBarClass: tabBarClass,
        secondary: secondary
      }, children);
      if (renderTabBar) {
        return renderTabBar(header);
      }
      return header;
    };

    _this.renderContent = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          renderTabContent = _this$props2.renderTabContent;

      var tabContentClasses = (0, _classnames3.default)('a-tab-content');
      var results = [];

      _react2.default.Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }
        var itemValue = child.props.value;

        var key = typeof itemValue === 'undefined' ? index : itemValue;
        var active = _this.state.currentValue === key;
        results.push(_react2.default.cloneElement(child, _extends({
          active: active,
          key: index
        }, child.props)));
      });
      var content = _react2.default.createElement(
        'div',
        { key: 'tabcontent', className: tabContentClasses },
        results
      );
      if (renderTabContent) {
        return renderTabContent(content);
      }
      return content;
    };

    if (props.defaultValue) {
      _this.state = { currentValue: props.defaultValue };
    } else if (props.children && props.children.length > 0) {
      _this.state = { currentValue: props.children[0].props.value };
    }
    return _this;
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className,
          tabBarClass = _props.tabBarClass,
          children = _props.children,
          onChange = _props.onChange,
          defaultValue = _props.defaultValue,
          centered = _props.centered,
          renderTabBar = _props.renderTabBar,
          renderTabContent = _props.renderTabContent,
          secondary = _props.secondary,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'tabBarClass', 'children', 'onChange', 'defaultValue', 'centered', 'renderTabBar', 'renderTabContent', 'secondary']);

      var renderHeader = this.renderHeader,
          renderContent = this.renderContent;

      var tabswrapperClasses = (0, _classnames3.default)('a-tabs-wrapper', _defineProperty({}, className, className));

      return _react2.default.createElement(
        'div',
        Object.assign({ style: style, className: tabswrapperClasses }, otherProps),
        renderHeader(),
        renderContent()
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.value) {
        return {
          currentValue: nextProps.value
        };
      }
      return {};
    }
  }]);

  return Tabs;
}(_react.Component);

Tabs.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  tabBarClass: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  centered: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  renderTabBar: _propTypes2.default.func,
  renderTabContent: _propTypes2.default.func,
  secondary: _propTypes2.default.bool
};

Tabs.displayName = 'Tabs';

exports.default = Tabs;